import { getHeaders } from '@utility/helperFunction';

export const GET_OUT_OF_STOCK_ITEMS_LIST_REQUESTED = 'stock/GET_OUT_OF_STOCK_ITEMS_LIST_REQUESTED';
export const GET_OUT_OF_STOCK_ITEMS_LIST_SUCCESS = 'stock/GET_OUT_OF_STOCK_ITEMS_LIST_SUCCESS';
export const GET_OUT_OF_STOCK_ITEMS_LIST_FAILURE = 'stock/GET_OUT_OF_STOCK_ITEMS_LIST_FAILURE';

export const GET_OUT_OF_STOCK_MODIFIERS_LIST_REQUESTED = 'stock/GET_OUT_OF_STOCK_MODIFIERS_LIST_REQUESTED';
export const GET_OUT_OF_STOCK_MODIFIERS_LIST_SUCCESS = 'stock/GET_OUT_OF_STOCK_MODIFIERS_LIST_SUCCESS';
export const GET_OUT_OF_STOCK_MODIFIERS_LIST_FAILURE = 'stock/GET_OUT_OF_STOCK_MODIFIERS_LIST_FAILURE';

export const UPDATE_ITEMS_STOCK_REQUESTED = 'stock/UPDATE_ITEMS_STOCK_REQUESTED';
export const UPDATE_ITEMS_STOCK_SUCCESS = 'stock/UPDATE_ITEMS_STOCK_SUCCESS';
export const UPDATE_ITEMS_STOCK_FAILURE = 'stock/UPDATE_ITEMS_STOCK_FAILURE';

export const UPDATE_MODIFIERS_STOCK_REQUESTED = 'stock/UPDATE_MODIFIERS_STOCK_REQUESTED';
export const UPDATE_MODIFIERS_STOCK_SUCCESS = 'stock/UPDATE_MODIFIERS_STOCK_SUCCESS';
export const UPDATE_MODIFIERS_STOCK_FAILURE = 'stock/UPDATE_MODIFIERS_STOCK_FAILURE';

export const GET_SEARCH_ITEM_STOCK_REQUESTED = 'stock/GET_SEARCH_ITEM_STOCK_REQUESTED';
export const GET_SEARCH_ITEM_STOCK_SUCCESS = 'stock/GET_SEARCH_ITEM_STOCK_SUCCESS';
export const GET_SEARCH_ITEM_STOCK_FAILURE = 'stock/GET_SEARCH_ITEM_STOCK_FAILURE';

export const GET_SEARCH_MODIFIERS_STOCK_REQUESTED = 'stock/GET_SEARCH_MODIFIERS_STOCK_REQUESTED';
export const GET_SEARCH_MODIFIERS_STOCK_SUCCESS = 'stock/GET_SEARCH_MODIFIERS_STOCK_SUCCESS';
export const GET_SEARCH_MODIFIERS_STOCK_FAILURE = 'stock/GET_SEARCH_MODIFIERS_STOCK_FAILURE';



const initialState = {
    loading: false,
    loaded: false,
    error: false,
};

const setLoadingState = state => ({
    ...state,
    loading: true,
    loaded: false,
    error: false,
});

const setLoadedState = state => ({
    ...state,
    loading: false,
    loaded: true,
    error: false,
});

const setErrorState = state => ({
    ...state,
    loading: false,
    loaded: false,
    error: true,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_OUT_OF_STOCK_ITEMS_LIST_REQUESTED:
        case GET_OUT_OF_STOCK_MODIFIERS_LIST_REQUESTED:
        case UPDATE_ITEMS_STOCK_REQUESTED:
        case UPDATE_MODIFIERS_STOCK_REQUESTED:
        case GET_SEARCH_ITEM_STOCK_REQUESTED:
        case GET_SEARCH_MODIFIERS_STOCK_REQUESTED:
            return setLoadingState(state);


        case GET_OUT_OF_STOCK_ITEMS_LIST_SUCCESS:
        case GET_OUT_OF_STOCK_MODIFIERS_LIST_SUCCESS:
        case UPDATE_ITEMS_STOCK_SUCCESS:
        case UPDATE_MODIFIERS_STOCK_SUCCESS:
        case GET_SEARCH_ITEM_STOCK_SUCCESS:
        case GET_SEARCH_MODIFIERS_STOCK_SUCCESS:
            return setLoadedState(state);

        case GET_OUT_OF_STOCK_ITEMS_LIST_FAILURE:
        case GET_OUT_OF_STOCK_MODIFIERS_LIST_FAILURE:
        case UPDATE_ITEMS_STOCK_FAILURE:
        case UPDATE_MODIFIERS_STOCK_FAILURE:
        case GET_SEARCH_ITEM_STOCK_FAILURE:
        case GET_SEARCH_MODIFIERS_STOCK_FAILURE:
            return setErrorState(state);

    }
}

export const getOutOfStockItemList = (data) => {
    const headers = getHeaders();

    return {
        types: [
            GET_OUT_OF_STOCK_ITEMS_LIST_REQUESTED,
            GET_OUT_OF_STOCK_ITEMS_LIST_SUCCESS,
            GET_OUT_OF_STOCK_ITEMS_LIST_FAILURE,
        ],
        promise: client => client.post('getOutOfStockItemList', { data, headers })
    }
}

export const getOutOfStockModifierList = (data) => {
    const headers = getHeaders();

    return {
        types: [
            GET_OUT_OF_STOCK_MODIFIERS_LIST_REQUESTED,
            GET_OUT_OF_STOCK_MODIFIERS_LIST_SUCCESS,
            GET_OUT_OF_STOCK_MODIFIERS_LIST_FAILURE,
        ],
        promise: client => client.post('getOutOfStockModifierList', { data, headers })
    }
}

export const updateItemStock = (data) => {
    const headers = getHeaders();

    return {
        types: [
            UPDATE_ITEMS_STOCK_REQUESTED,
            UPDATE_ITEMS_STOCK_SUCCESS,
            UPDATE_ITEMS_STOCK_FAILURE,
        ],
        promise: client => client.post('updateItemStock', { data, headers })
    }
}

export const updateModifierStock = (data) => {
    const headers = getHeaders();

    return {
        types: [
            UPDATE_MODIFIERS_STOCK_REQUESTED,
            UPDATE_MODIFIERS_STOCK_SUCCESS,
            UPDATE_MODIFIERS_STOCK_FAILURE,
        ],
        promise: client => client.post('updateModifierStock', { data, headers })
    }
}

export const searchItemStock = (data) => {
    const headers = getHeaders();

    return {
        types: [
            GET_SEARCH_ITEM_STOCK_REQUESTED,
            GET_SEARCH_ITEM_STOCK_SUCCESS,
            GET_SEARCH_ITEM_STOCK_FAILURE,
        ],
        promise: client => client.post('searchItemStock', { data, headers })
    }
}

export const searchModifierStock = (data) => {
    const headers = getHeaders();

    return {
        types: [
            GET_SEARCH_MODIFIERS_STOCK_REQUESTED,
            GET_SEARCH_MODIFIERS_STOCK_SUCCESS,
            GET_SEARCH_MODIFIERS_STOCK_FAILURE,
        ],
        promise: client => client.post('searchModifierStock', { data, headers })
    }
}